import React, { useState } from 'react';

const ROLES = ['Global Staffing Firm','EOR / AOR Provider','Recruitment Agency','Corporate HR / Finance','Other'];

const INITIAL = { firstName:'', lastName:'', email:'', company:'', role:'', countries:'', message:'' };

export default function Contact() {
  const [form,    setForm]    = useState(INITIAL);
  const [status,  setStatus]  = useState('idle'); // idle | sending | success | error
  const [errMsg,  setErrMsg]  = useState('');

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrMsg('');

    // Validation
    const required = ['firstName','lastName','email','company','role'];
    if (required.some(k => !form[k]?.trim())) {
      setErrMsg('Please fill in all required fields.');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      setErrMsg('Please enter a valid work email address.');
      return;
    }

    setStatus('sending');

    // TODO: replace with your backend endpoint
    // e.g. await fetch('/api/contact', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(form) });
    await new Promise(r => setTimeout(r, 800)); // simulated delay

    setForm(INITIAL);
    setStatus('success');
  };

  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="contact-inner">

          <div className="contact-text">
            <div className="section-label">Contact</div>
            <h2 className="contact-title">Ready to see it in action?</h2>
            <p>Request a live demo or ask us anything. Our team will come back to you within one business day.</p>
            <div className="contact-detail">
              <EmailIcon/>
              <a href="mailto:sales@quoteology.net">sales@quoteology.net</a>
            </div>
          </div>

          {status === 'success' ? (
            <div className="form-success" style={{ display:'flex' }}>
              <div className="success-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </div>
              <div className="success-body">
                <div className="success-title">Request received — thank you.</div>
                <p className="success-msg">
                  A member of our team will review your request and reach out within one business day.
                  If you have an urgent question in the meantime, you can email us directly at{' '}
                  <a href="mailto:sales@quoteology.net">sales@quoteology.net</a>.
                </p>
              </div>
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit} noValidate>
              <div className="form-row">
                <Field label="First name" id="firstName" value={form.firstName} onChange={set('firstName')} autoComplete="given-name"/>
                <Field label="Last name"  id="lastName"  value={form.lastName}  onChange={set('lastName')}  autoComplete="family-name"/>
              </div>
              <Field label="Work email" id="email"   type="email" value={form.email}   onChange={set('email')}   autoComplete="email"/>
              <Field label="Company"    id="company"              value={form.company}  onChange={set('company')}/>
              <div className="form-field">
                <label htmlFor="role">Your role</label>
                <select id="role" value={form.role} onChange={set('role')} required>
                  <option value="">Select…</option>
                  {ROLES.map(r => <option key={r}>{r}</option>)}
                </select>
              </div>
              <Field
                label="Countries of interest"
                id="countries"
                value={form.countries}
                onChange={set('countries')}
                placeholder="e.g. Japan, Norway, Netherlands"
              />
              <div className="form-field">
                <label htmlFor="message">Anything else you'd like us to know</label>
                <textarea
                  id="message" rows={4}
                  value={form.message}
                  onChange={set('message')}
                  placeholder="Tell us about your team size, current process, or what you'd like to see in the demo."
                />
              </div>
              {errMsg && <div className="form-error" style={{ display:'block' }}>{errMsg}</div>}
              <button type="submit" className="btn-primary btn-submit" disabled={status === 'sending'}>
                {status === 'sending' ? 'Sending…' : 'Send request'}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}

function Field({ label, id, type='text', value, onChange, autoComplete, placeholder }) {
  return (
    <div className="form-field">
      <label htmlFor={id}>{label}</label>
      <input
        id={id} type={type} value={value} onChange={onChange}
        autoComplete={autoComplete} placeholder={placeholder} required
      />
    </div>
  );
}

function EmailIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
      <polyline points="22,6 12,13 2,6"/>
    </svg>
  );
}
